import Category from "../components/Category";
import BreadcrumbShop from "../components/BreadcrumbShop";

const Laptop = () => {
  return (
    <div>
      <BreadcrumbShop curPage={"Laptop"} />
      <Category talk={"Laptop"} />
    </div>
  );
};

export default Laptop;
